import React from 'react';
import { Box } from '@mui/material';
import { styles } from './statusChip.style';
import { STATUS_BACKGROUND_COLORS, STATUS_COLORS } from '../constants';

const StatusChip = ({ status }) => {
  if (!status) return;
  const background = STATUS_BACKGROUND_COLORS[status];
  const color = STATUS_COLORS[status];
  return (
    <Box sx={styles.chip(background, color)}>
      <Box sx={styles.text(color)}>{status}</Box>
    </Box>
  );
};

export default StatusChip;
